import * as yup from 'yup';
import { reasonRefusalForm } from '../../services/types';

const regex = /[\w\sÀ-ÖØ-öø-ÿa-zA-Z0-9]+/;

const validationSchema = yup.object().shape({
  reason: yup
    .string()
    .matches(regex, 'Motivo deve conter apenas letras e números')
    .required('Motivo não pode estar vazio')
    .max(255, 'A razão deve ter até no máximo 150 caracteres'),
  description: yup
    .string()
    .matches(regex, 'Descrição deve conter apenas letras e números')
    .required('Descrição não pode estar vazia')
    .max(255, 'A descrição pode ter até no máximo 150 caracteres'),
}) as yup.ObjectSchema<reasonRefusalForm>;

export default validationSchema;
